import appConstants from "../../../../appConstants";

const GEOCODE_TYPES = {
    SHIPMENT:"SHIPMENT",
    PICKUP:"PICKUP",
    DELIVERY_STOP:"DELIVERY_STOP",
}

export const GEOCODE_OPTIONS = {
    [GEOCODE_TYPES.SHIPMENT]: {
      apiName: "UpdateShipmentCustomerLocation",
      getRequestParams: (customer, updatedLocation, userData) => ({
        scenarioId: userData.scenarioID,
        planDate: userData.planDate,
        terminalId: userData.terminal.id,
        ...(customer.id && {customerId: customer.id}),
        ...(customer.rmaxShipperCode && {rmaxShipperCode: customer.rmaxShipperCode}),
        oldLocation: {
          latitude: customer.latitude,
          longitude: customer.longitude,
        },
        latitude: updatedLocation.lat,
        longitude: updatedLocation.lng,
      }),
    },
    [GEOCODE_TYPES.PICKUP]: {
      apiName: "UpdatePickupCustomerLocation",
      getRequestParams: (customer,updatedLocation,userData) => ({
        terminalCode:  userData.terminal.code,
        pickupId: customer.pickupId,
        rmaxShipperCode: customer.id,
        latitude: updatedLocation.lat,
        longitude: updatedLocation.lng,
        eventDateTime: new Date(),
      }),
    },
    [GEOCODE_TYPES.DELIVERY_STOP]: {
      apiName: "UpdateDeliveryCustomerLocation",
      getRequestParams: (customer,updatedLocation,userData) => ({
        terminalCode: userData.terminal.code,
        customerCode: customer.id,
        latitude: updatedLocation.lat,
        longitude: updatedLocation.lng,
        eventDateTime: new Date(),
      }),
    },
};
  
export const getShipmentCustomerData = (shipment) => {
  const commonData = {
    code: shipment.customerCode, // Guid for misc customers and number for normal customers
    isMiscellaneousCustomer: shipment.isMiscellaneousCustomer,
    type: GEOCODE_TYPES.SHIPMENT,
    isDelivery: shipment.isDelivery,
    latitude: shipment.latitude,
    longitude: shipment.longitude,
  }
  if (shipment.isDelivery) {
    return {
      ...commonData,
      id: shipment.customerId,
      name: shipment.consigneeName,
      address: shipment.consigneeAddress,
      city: shipment.city,
      state: shipment.state,
      zip: shipment.zip,
      number: shipment.consigneeCode, // code starts with R for display purpose
      isGeoCoded: shipment.isGeoCoded,
    }
  }
  return {
    ...commonData,
    rmaxShipperCode: shipment.rmaxShipperCode,
    name: shipment.shipperName,
    address: shipment.shipperAddress,
    city: shipment.shipperCity,
    state: shipment.shipperState,
    zip: shipment.shipperZip,
    number: shipment.shipperCode,
    isGeoCoded: shipment.isShipperGeoCoded,
  };
};

export const getCustomerManagementData = (
  customerManagementData,
  customerType = appConstants.CUSTOMER_TYPE.DELIVERY
) => {
  const commonData = {
    number: customerManagementData.code, // code starts with R for display purpose
    code: customerManagementData.code, // Guid for misc customers and number for normal customers
    name: customerManagementData.name,
    address: customerManagementData.address,
    city: customerManagementData.city,
    state: customerManagementData.state,
    zip: customerManagementData.zip,
    latitude: customerManagementData.latitude,
    longitude: customerManagementData.longitude,
    type: GEOCODE_TYPES.SHIPMENT, //use Shipment configuration to call Shipment Management geocoding API in Customer Managment as well.
  };
  if (customerType === appConstants.CUSTOMER_TYPE.DELIVERY) {
    return {
      ...commonData,
      id: customerManagementData.deliveryDetails.customerId,
      isMiscellaneousCustomer:
        customerManagementData.deliveryDetails.isMiscCustomer,
      isGeoCoded: customerManagementData.deliveryDetails.isGeoCoded,
    };
  }
  return {
    ...commonData,
    rmaxShipperCode: customerManagementData.pickupDetails.rmaxShipperCode,
    isGeoCoded: customerManagementData.pickupDetails.isGeoCoded,
  };
};

export const getStopCustomerData = (stop) => {
    return {
        id: stop.code,
        number: stop.accountNumber,
        name: stop.name,
        address: stop.address,
        city:stop.city,
        state: stop.state,
        zip: stop.zip,
        latitude: stop.latitude,
        longitude:  stop.longitude,
        pickupId: stop.pickupId,
        isGeoCoded: stop.isGeoCoded,
        type: stop.pickupId ? GEOCODE_TYPES.PICKUP : GEOCODE_TYPES.DELIVERY_STOP
    }
}

export const getPickupCustomerData = (pickup) => {
    return  {
        id: pickup.rmaxShipperCode,
        number: pickup.shipperAccountNumber,
        name: pickup.shipperName,
        address: pickup.shipperAddress,
        city:pickup.shipperCity,
        state: pickup.shipperState,
        zip: pickup.shipperZip,
        latitude: pickup.shipperLatitude,
        longitude:  pickup.shipperLongitude,
        pickupId: pickup.pickupId,
        isGeoCoded: pickup.isGeoCoded,
        type: GEOCODE_TYPES.PICKUP
    }
}
